import { Pipe, PipeTransform } from '@angular/core';
import {
  SchoolNameSource,
  TabloTextConfig,
  TabloTextConfigOptions,
} from '@ui/tablo-generator/types';
import { getTabloYearDetails } from './add-year-details.pipe';
import { preventSingleLetterWidows } from './typography.utils';

const resolveSourceText = (value: TabloTextConfig): string => {
  switch (value.config.pickedNameSource) {
    case SchoolNameSource.Official:
      return value.officialName || '';
    case SchoolNameSource.Short:
      return value.shortName || '';
    case SchoolNameSource.Classic:
    default:
      return value.config.text || '';
  }
};

const trimOrEmpty = (value: string | null | undefined) => value?.trim() || '';

const buildTabloTextParts = (
  config: TabloTextConfigOptions,
  value: TabloTextConfig,
) =>
  [
    trimOrEmpty(config.beforeText),
    trimOrEmpty(resolveSourceText(value)),
    trimOrEmpty(getTabloYearDetails(config)),
    trimOrEmpty(config.afterText),
  ].filter((part) => !!part);

export const resolveTabloTextValue = (
  value: TabloTextConfig | null | undefined,
) => {
  if (!value?.config) {
    return '';
  }

  return preventSingleLetterWidows(
    buildTabloTextParts(value.config, value).join(' '),
  );
};

@Pipe({
    name: 'resolveTabloText',
    standalone: false
})
export class ResolveTabloTextPipe implements PipeTransform {
  transform(value: TabloTextConfig | null | undefined): string {
    return resolveTabloTextValue(value);
  }
}
